"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _user = require("@/api/user");
var _user2 = require("@/api/iot/user");
var _status = require("@/api/iot/status");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _authInfoDialog = _interopRequireDefault(require("@/components/dialogs/authInfoDialog"));
var _userProxy = _interopRequireDefault(require("@/components/dialogs/userProxy"));
var _ProxyEditForm = _interopRequireDefault(require("./components/ProxyEditForm.vue"));
var _merchant = require("@/api/merchant");
var _default = {
  components: {
    customPage: _customPage.default,
    authInfoDialog: _authInfoDialog.default,
    userProxy: _userProxy.default,
    ProxyEditForm: _ProxyEditForm.default
  },
  props: ['shopname'],
  data: function data() {
    return {
      loading: false,
      drawerTableShow: false,
      searchForm: {
        cert_name: '',
        mobile: '',
        proxy_id: null
      },
      total: 0,
      tableData: [],
      routerName: '',
      editItem: null,
      signStatusList: [],
      drawerData: [],
      merchantList: []
    };
  },
  // computed: {
  //   shopname(){
  //     console.log('shopname1',this.$route.query.shopname)
  //   }
  // },
  created: function created() {
    console.log('shopname1', this.$route.query.cert_name);
    if (this.$route.query.cert_name) {
      this.searchForm.cert_name = this.$route.query.cert_name;
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getEsignSignStatusList();
    this.getList();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'memberView') {
      next(function (vm) {
        vm.getList();
      });
    } else {
      next();
    }
  },
  methods: {
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getEsignSignStatusList: function getEsignSignStatusList() {
      var _this = this;
      (0, _status.getEsignSignStatusList)().then(function (res) {
        console.log('getEsignSignStatusList', res);
        if (res) {
          _this.signStatusList = res || [];
        }
      });
    },
    getList: function getList(flag) {
      var _this2 = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _user.getInviteList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this2.loading = false;
        _this2.tableData = res.data || [];
        _this2.total = res.total;
      });
    },
    handleMore: function handleMore(command, item) {
      console.log(command, item);
      // this.selectedItem = item;
      if (command == 'edit') {
        // 编辑资料
        this.$router.push({
          name: 'memberView',
          params: {
            viewId: item.id,
            toEdit: true
          }
        });
      } else {
        // 查看备注
      }
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = {
        cert_name: '',
        mobile: '',
        proxy_id: null
      };
      this.routerName = '';
      this.getList();
    },
    // 启用/禁用
    enable: function enable(id, endisable) {
      var _this3 = this;
      editSupplier({
        id: id,
        endisable: endisable == 1 ? 2 : 1
      }).then(function (res) {
        _this3.getList(true);
      });
    },
    is_break: function is_break(data) {
      var _this4 = this;
      var type = data.is_black == 0 ? 1 : 0;
      (0, _user.saveMemberBreak)({
        type: type,
        id: data.id
      }).then(function (res) {
        _this4.getList();
      });
    },
    is_black_type: function is_black_type(type) {
      return type == 0 ? 'warning' : 'primary';
    },
    // 用户认证信息
    openAuthInfoDialog: function openAuthInfoDialog(val) {
      this.editItem = val || null;
      this.$refs.authInfoDialog.dialogVisible = true;
    },
    //设置下级分佣信息
    openProxyMemberDialog: function openProxyMemberDialog(val) {
      this.editItem = val || null;
      this.$refs.proxyEditForm.dialogVisible = true;
    },
    // 删除下级分佣信息
    handleDeleteProxyMember: function handleDeleteProxyMember(_ref) {
      var _this5 = this;
      var id = _ref.id;
      this.$confirm('此操作将删除下级分佣信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _user.deleteProxyMember)({
          id: id
        }).then(function (res) {
          _this5.getList(true);
        });
      });
    },
    // 修改分佣到账信息
    handleEditProxyAccount: function handleEditProxyAccount(_ref2) {
      var _this6 = this;
      var id = _ref2.id;
      this.$confirm('此操作将划入该笔分佣到代理人账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _user.setProxyMemberPayState)({
          id: id
        }).then(function (res) {
          _this6.getList(true);
        });
      });
    },
    // 打开drawer
    openProxyDrawer: function openProxyDrawer() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.editItem = item || null;
      // this.drawerTableShow = true
      this.$router.push({
        name: 'chkgBatteryBunker',
        query: {
          terminal_no: item.terminal_no
        }
      });
    },
    // 查看合同
    getEsignContract: function getEsignContract(item) {
      var _this7 = this;
      this.loading = true;
      (0, _user2.getEsignContract)({
        flow_id: item.esign_flow_id
      }).then(function (res) {
        // console.log('getEsignContract', res)
        // console.log('res.files.downloadUrl', res.files[0].downloadUrl)
        _this7.loading = false;
        if (res) {
          window.open(res.files[0].downloadUrl);
        }
      }).catch(function (err) {
        return _this7.loading = false;
      });
    }
  }
};
exports.default = _default;